<!-- /*
* TODO: Remover esse layout após todas as merchants da listagem efetuarem o reset de chaves secretas.
* Suas respectivas chamadas, enum e action-permissions também deverão ser removidos.
* keys.permissions: remover a função isSecretKeyOutdatedEnabled.
* enums/secret-key-outdated.enum: remover enum
* call: remover chamada do layout na Motherboard.vue
* Data da implementação: 2024-07-24
* Responsáveis: @Trocatti, @Pedro Henrique Lourenco Monteiro e @Léo Martins
*/ -->

<template>
  <div :data-component="$options.name">
    <jade-navigation-bar
      background="body"
      navigateType="back"
      :label="$t('navigate')"
      @onNavigate="redirectToCompany"
    />

    <section class="container">
      <jade-alert
        showIcon
        variant="warning"
        icon="warning"
        :title="$t('title')"
      >
        {{ $t('description') }}
      </jade-alert>
      <secret-keys />
    </section>

    <app-footer />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { JadeAlert, JadeNavigationBar } from '@/components/jade'

import { EXTERNAL_ENDPOINTS } from '@/external-endpoints/index.js'

export default {
  name: 'LayoutSecretKeyOutdated',
  components: {
    JadeAlert,
    JadeNavigationBar,
    SecretKeys: () => import('@/views/Account/Keys/SecretKeys.vue'),
    AppFooter: () => import('@/components/project/globals/Footer.vue')
  },

  computed: {
    ...mapGetters(['merchantId'])
  },

  methods: {
    redirectToCompany () {
      window.location.replace(EXTERNAL_ENDPOINTS.COMPANY.url(this.merchantId))
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 90%;
  margin: 0 auto;
  padding: var(--global-space-500, 12px);
}
</style>

<i18n>
  {
    "pt-BR": {
      "navigate": "Voltar",
      "title": "Conta limitada, execute as ações abaixo para desbloquear:",
      "description":"Você precisa excluir todas as Chaves da API (Secret Key) criadas antes de 21/09/2023 e recria-las para continuar utilizando nosso dashboard e suas funcionalidades"
    },
    "en-US": {
      "navigate": "Voltar",
      "title": "Limited account, perform the actions below to unlock:",
      "description":"You need to delete all secret keys created before 21/09/2023, and recreate the keys (Secret Key) to continue using Dash 2.0 and all its features."
    }
  }
</i18n>
